import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import { Grid, ClickAwayListener, IconButton, Popover, Tooltip } from '@mui/material';
import { useState } from 'react';
import { ICandidate } from 'wisestep-api';
import { WsColors } from 'wisestep-base';

import StageStatusDialogToolTip from './StageStatusDialogToolTip';

interface IStageStatusDialogTool {
  candidateInfo: ICandidate;
  userStageStatus: [];
  updateUI: (candidate: ICandidate) => void;
}

const StageStatusDialogTool = ({
  candidateInfo,
  userStageStatus,
  updateUI,
}: IStageStatusDialogTool) => {
  const [openStageStatusDialog, setOpenStageStatusDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>();

  const handleClose = () => {
    setOpenStageStatusDialog(false);
  };
  const onClickAway = () => {};

  const viewCandidateInfo = () => setOpenStageStatusDialog(true);

  const handlePopoverOpen = (event) => setAnchorEl(event?.currentTarget);

  return (
    <Grid item>
      <ClickAwayListener onClickAway={onClickAway}>
        <div>
          <IconButton
            onClick={(event) => {
              viewCandidateInfo();
              handlePopoverOpen(event);
            }}
            sx={{ color: WsColors.TheBlues400 }}
          >
            <Tooltip title="Update Stage & Status">
              <ExpandCircleDownIcon />
            </Tooltip>
          </IconButton>
          <Popover
            open={openStageStatusDialog}
            onClose={handleClose}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            PaperProps={{
              style: {
                width: '350px',
                height: '550px',
                borderRadius: '10px',
              },
            }}
          >
            <StageStatusDialogToolTip
              closeDialog={() => {
                handleClose();
              }}
              candidate={candidateInfo}
              userStageStatus={userStageStatus}
              updateUI={updateUI}
            />
          </Popover>
        </div>
      </ClickAwayListener>
    </Grid>
  );
};
export default StageStatusDialogTool;
